module.exports = __webpack_public_path__ + "img/t5.01eeee85.png";